import { render, staticRenderFns } from "./device-register.vue?vue&type=template&id=aff68468&scoped=true&"
import script from "./device-register.vue?vue&type=script&lang=js&"
export * from "./device-register.vue?vue&type=script&lang=js&"
import style0 from "./device-register.vue?vue&type=style&index=0&id=aff68468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff68468",
  null
  
)

export default component.exports